// 定义项目内的表名
const openToBeInvoicedList =
  "open-invoice/open-invoice-children/open-to-be-invoiced-list";

const tableList = {
  openToBeInvoicedList
};
export default tableList;
